import { Controller } from "@hotwired/stimulus"

// Copies a read-only field's value and announces the result. If the Clipboard API is unavailable
// the text is selected so it can be copied by hand.
// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source", "status"]

  disconnect() {
    clearTimeout(this.timer)
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.announce("Copied")
    } catch {
      this.sourceTarget.select()
      this.announce("Selected — press Ctrl+C or ⌘C to copy")
    }
  }

  announce(message) {
    this.statusTarget.textContent = message
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.statusTarget.textContent = "" }, 2500)
  }
}
